


























import { Component, Vue, Prop } from 'vue-property-decorator';
import { overtenThousand } from '@/utils'
import { isEmpty } from 'lodash'
import { postMessage } from '../utils'
import AnchorCard from './AnchorCard.vue'

@Component({
  components: {
    AnchorCard
  },
})
export default class AuthorInfo extends Vue {
  private sid!: string
  private showAnchorDeatil = false
  private loadingInstance: any
  private hideFollow = false

  private get author () {
    return this.$store.state.currentAuthor
  }

 private withLogin (func) {
    if (this.$store.state.userInfo.isTourist) {
      this.$weui.dialog({
        title: '提示',
        content: '请先登录',
        buttons: [{
            label: '确定',
            type: 'primary',
            onClick: () => {console.log('确定')}
        }]
      })
      return
    }
    func()
  }

  private setshowAnchorDeatil () {
    if (isEmpty(this.$store.state.currentAuthor)) {
      return
    }
    postMessage({
      userAction: 0,
      actionParam: 0
    })
    this.showAnchorDeatil = !this.showAnchorDeatil
  }

  private get nowPerson () {
    // 观看直播累计人数
    const { showTotalPerson } = this.$route.query
    if (showTotalPerson) {
      return overtenThousand(this.$store.state.liveRoomInteractionInfo.personTotal)
    }
    return overtenThousand(this.$store.state.liveRoomInteractionInfo.nowPerson)
  }

  private get giftCount () {
    return overtenThousand(this.$store.state.liveRoomInteractionInfo.giftCount)
  }

  private get upCount () {
    return overtenThousand(this.$store.state.liveRoomInteractionInfo.upCount)
  }

  private get anchorDeatil () {
    return this.$store.state.anchorDeatil
  }

  private get noStartLive () {
    return isEmpty(this.author)
  }

  private get showFollowBtn () {
    return !this.noStartLive && !this.isFollow && !isEmpty(this.$store.state.anchorDeatil)
  }

  private get isFollow () {
    return +this.$store.state.anchorDeatil.isFollow === 1
  }

  private async subAuthor () {
    this.$store.dispatch('updateAuthorDetail')
  }

  private get anthorInfoTop () {
    const { businessType, redirectUrl } = this.$route.query
    return +businessType === 1 && redirectUrl
  }

  private mounted() {
    const { hideFollow } = this.$route.query
    this.hideFollow = hideFollow === '1'
  }
}
